import React, { useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { LOGIN_PAGE, ROOT } from 'admin/constants/routes';
import { toast } from 'admin/components/common/MessageContainer/toast';
import { getResponseErrorMsg } from 'common/resources/api-response';
import { ADMIN_PASSWORD_SESSION, ADMIN_SESSION, ADMIN_SSO_SESSION } from 'common/constants';
import { completeOrganizationSSO } from 'admin/queries/auth/sso-login';

const SsoOAuth: React.FC = () => {
	const { organizationSlug } = useParams<{ organizationSlug: string }>();
	const [redirectTo, setRedirectTo] = useState<string | null>(null);

	useEffect(() => {
		const url = new URL(window.location.href);
		const state = url.searchParams.get('state');
		const code = url.searchParams.get('code');

		if (!code || !state || !organizationSlug) {
			toast.error('Missing data.');
			setRedirectTo(LOGIN_PAGE);
			return undefined;
		}

		let cancelled = false;

		completeOrganizationSSO({ organizationSlug, code, state })
			.then(async result => {
				if (!result) {
					if (cancelled) return;
					toast.error('No result.');
					setRedirectTo(LOGIN_PAGE);
					return;
				}

				if (result.emailMismatch) {
					if (cancelled) return;
					toast.error('Email mismatch.');
					setRedirectTo(LOGIN_PAGE);
					return;
				}

				const sessionId = localStorage.getItem(ADMIN_SESSION);
				if (!sessionId) throw new Error('SSO login did not create a session.');
				localStorage.setItem(ADMIN_SSO_SESSION, sessionId);
				localStorage.removeItem(ADMIN_PASSWORD_SESSION);

				if (cancelled) return;

				setRedirectTo(result.redirectTo || ROOT);
			})
			.catch(error => {
				if (cancelled) return;
				toast.error(getResponseErrorMsg(error));
				setRedirectTo(LOGIN_PAGE);
			});

		return () => {
			cancelled = true;
		};
	}, [organizationSlug]);

	return redirectTo ? <Redirect to={redirectTo} /> : null;
};

export default SsoOAuth;
